import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperStyles = ({ theme }) => css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;

  ${theme.media.kilo} {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
  }

  ${theme.media.mega} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
